export default __webpack_public_path__ + "static/media/elevate-bbl-poster-1.175cc271.jpg";